import { SHOW_TBW_SAVE_BUTTON } from "../../../../../constants/input-entries-constants";
import getTBWStore from "../../../../../stores/developer-store/tbw-store";
import Et3Button from "../../../../et3-button";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";

const SaveButton = withLiteObserverAndTheme(() => {
  const TBWFromCase = getTBWStore().TBWFromCase.get();
  const shouldDisable = getTBWStore().disableTbwActionButton.get();
  const shouldShow = SHOW_TBW_SAVE_BUTTON.indexOf(TBWFromCase) > -1;

  return shouldShow ? (
    <Et3Button
      isEnabled={!shouldDisable}
      onClick={async () => {
        await getTBWStore().warnBanUser({
          shouldAddToInvestigate: false
        });
        getTBWStore().resetTBWPopUp();
      }}
      size="MEDIUM"
      type="APPROVE"
      text="SAVE"
    />
  ) : null;
});

export default SaveButton;
